<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemModel as RegulationsSetListItemModel } from '../../../pages/cms/marketing/regulations/_runtime/services/RegulationsSetsService';
import RegulationsSetsService from '../../../pages/cms/marketing/regulations/_runtime/services/RegulationsSetsService';
import type { ListItemModel as CategoryListItemModel } from '../../../pages/cms/marketing/subscriptions/_runtime/services/SubscriptionsCategoriesService';
import SubscriptionsCategoriesService from '../../../pages/cms/marketing/subscriptions/_runtime/services/SubscriptionsCategoriesService';

defineOptions({
    name: 'WidgetNewsletterSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const { $log } = useLogging();
const { $t } = useLocalization();

const defaults = ref<any>({
    showTitle: false,
    regulationsSetId: null,
    categoryId: null,
    content: ''
});
const regulationsSets = ref<RegulationsSetListItemModel[]>([]);
const categories = ref<CategoryListItemModel[]>([]);

const form = computed<any>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function loadRegulationsSets(): Promise<boolean>
{
    try
    {
        const response = await RegulationsSetsService.getAll();

        regulationsSets.value = [{
            id: null,
            name: $t('[[[Brak listy regulaminów]]]')
        }].concat(response.result as any) as any;

        for (const item of regulationsSets.value)
        {
            item.name = item.name ?? RegulationSetTypeName(item.type as RegulationSetType);
        }
    }
    catch (ex)
    {
        handleException($log, ex, {
            0: (ex: any) => form.value.$errors.push('parentId', $t('[[[Nie udało się pobrać listy regulaminów]]]'))
        });

        return false;
    }

    return true;
}

async function loadCategories(): Promise<boolean>
{
    try
    {
        const response = await SubscriptionsCategoriesService.getAll();

        categories.value = [{
            id: null,
            name: $t('[[[Brak kategorii]]]'),
            position: 0
        }].concat(response.result);
    }
    catch (ex)
    {
        handleException($log, ex, {
            0: (ex: any) => form.value.$errors.push('parentId', $t('[[[Nie udało się pobrać kategorii]]]'))
        });

        return false;
    }

    return true;
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    loadRegulationsSets();
    loadCategories();

    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :invalid-feedback="form.$errors.first('settings.showTitle')" :state="form.$errors.state('settings.showTitle')" :nospace="true">
        <IdeoFormCheckbox v-model="form.settings.showTitle">
            {{ $t('[[[Wyświetlaj tytuł]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Wybierz listę regulaminów]]]')" :invalid-feedback="form.$errors.first('settings.regulationsSetId')" :state="form.$errors.state('settings.regulationsSetId')">
        <IdeoFormSelect v-model="form.settings.regulationsSetId" name="regulationsSetId" :options="regulationsSets" value-field="id" text-field="name" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Wybierz kategorię subskrypcji]]]')" :invalid-feedback="form.$errors.first('settings.categoryId')" :state="form.$errors.state('settings.categoryId')">
        <IdeoFormSelect v-model="form.settings.categoryId" name="categoryId" :options="categories" value-field="id" text-field="name" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Opis]]]')" :invalid-feedback="form.$errors.first('settings.content')" :state="form.$errors.state('settings.content')">
        <RichTextEditor id="editorContent" v-model="form.settings.content" />
    </IdeoFormGroup>
</template>
